import { useQuery } from '@tanstack/react-query';

import { subscriptionClient } from 'services/connectivity/billing/client';
import { SubscriptionsResponse } from 'services/connectivity/billing/types';
import { getAccessToken } from 'helpers/account';
import { errorDeserialize } from 'helpers/error-deserializer';

interface IUseFetchFeatures {
  data: SubscriptionsResponse;
  isFetching: boolean;
}

export async function fetchSubscriptions(token: string): Promise<SubscriptionsResponse> {
  const { result, error } = await subscriptionClient.get(token);

  if (error) {
    throw errorDeserialize(error);
  }

  return result;
}

export function useFetchSubscriptions(): IUseFetchFeatures {
  const { data, isFetching } = useQuery({
    queryKey: ['subscriptions'],
    queryFn: () => fetchSubscriptions(getAccessToken()),
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return { data, isFetching };
}
